// extracted by mini-css-extract-plugin
export default {"Container":"YooKassa_Container__J8U81","Message":"YooKassa_Message__V11av"};